import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateOrgStructureAssignment as apiUpdate } from "../../api/apiOrgStructureAssignments";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useUpdateOrgStructureAssignment() {
    const navigate = useNavigate(); const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: editAssignment, isPending: isUpdate, error } = useMutation({
        mutationFn: ({ req, id }) => apiUpdate(req, id),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["orgStructureAssignments"] }); navigate('/org-structure-assignments'); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { editAssignment, isUpdate, error };
}
